import { Box, Card, CardContent, Grid, Stack, Typography } from "@mui/material";
import React, { useState } from "react";

// Service card data for mapping
const serviceCards = [
  {
    id: 1,
    title: "Software Installation",
    description:
      "Professional installation and setup of operating systems, business applications, and specialized software packages for your organization.",
    backgroundColor: "#2c3e50",
    iconColor: "#3498db",
  },
  {
    id: 2,
    title: "Network Setup",
    description:
      "Complete configuration of routers, switches, access points, and network security for optimized performance and reliability.",
    backgroundColor: "#34495e",
    iconColor: "#2ecc71",
  },
  {
    id: 3,
    title: "Troubleshooting",
    description:
      "Efficient diagnosis and resolution of hardware and software issues with minimal disruption to your business operations.",
    backgroundColor: "#2c3e50",
    iconColor: "#e74c3c",
  },
  {
    id: 4,
    title: "Remote Support",
    description:
      "Immediate technical assistance from anywhere with secure, encrypted remote access to your systems.",
    backgroundColor: "#34495e",
    iconColor: "#f39c12",
  },
  {
    id: 5,
    title: "Cybersecurity Services",
    description:
      "Comprehensive protection for your data and systems including firewall configuration, antivirus deployment, and security monitoring.",
    backgroundColor: "#2c3e50",
    iconColor: "#9b59b6",
  },
  {
    id: 6,
    title: "Cloud Solutions",
    description:
      "Expert migration, setup and management of cloud services for improved accessibility, scalability, and business continuity.",
    backgroundColor: "#34495e",
    iconColor: "#1abc9c",
  },
];

const ServiceCard = ({ service }) => {
  const [isHovered, setIsHovered] = useState(false);
  
  return (
    <Card
      sx={{
        height: "100%",
        borderRadius: "15px",
        backgroundColor: service.backgroundColor,
        transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
        transform: isHovered ? "translateY(-5px)" : "none",
        boxShadow: isHovered ? "0 10px 20px rgba(0,0,0,0.2)" : "none",
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <CardContent sx={{ p: 3 }}>
        <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" } }}>
          <Box
            sx={{
              width: { xs: "80px", md: "120px" },
              height: { xs: "80px", md: "120px" },
              borderRadius: "10px",
              backgroundColor: "rgba(255,255,255,0.1)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mb: { xs: 2, md: 0 },
              flexShrink: 0,
            }}
          >
            <Box
              sx={{
                width: { xs: "40px", md: "60px" },
                height: { xs: "40px", md: "60px" },
                borderRadius: "50%",
                backgroundColor: service.iconColor,
              }}
            />
          </Box>
          
          <Box sx={{ ml: { xs: 0, md: 3 } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 600,
                fontSize: { xs: "22px", md: "26px" },
                lineHeight: "31.2px",
                color: "#ffffff",
                mb: 1.5,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {service.title}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontSize: { xs: "14px", md: "16px" },
                lineHeight: "29px",
                color: "#b4b6b8",
              }}
            >
              {service.description}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default function ServicesSection() {
  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "#1a2533",
        py: { xs: 8, md: 12 },
      }}
    >
      <Box sx={{ maxWidth: 1200, mx: "auto", px: { xs: 2, md: 4 } }}>
        {/* Header Section */}
        <Stack spacing={3} alignItems="center" sx={{ mb: { xs: 6, md: 8 } }}>
          <Typography
            variant="h2"
            align="center"
            color="#fefefe"
            sx={{
              fontWeight: 600,
              fontSize: { xs: "36px", md: "50px" },
              lineHeight: { xs: "44px", md: "60px" },
              maxWidth: "612px",
            }}
          >
            Our Technical Services
          </Typography>
          <Typography
            variant="body1"
            align="center"
            color="#8b8b8b"
            sx={{
              fontSize: { xs: "15px", md: "17px" },
              lineHeight: "30px",
              maxWidth: "607px",
            }}
          >
            Comprehensive remote IT solutions designed to keep your business running smoothly, securely, and efficiently without on-site visits.
          </Typography>
        </Stack>

        {/* Services Grid */}
        <Grid container spacing={3} sx={{flexDirection: "row"}}>
          {serviceCards.map((service) => (
            <Grid item key={service.id} xs={12} md={6} lg={4} sx={{width: {xs: "100%", md:"49%"}}}>
              <ServiceCard service={service} />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}